var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gift-clip)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 11H10V23H5C3.89543 23 3 22.1046 3 21L3 11Z",
    fill: "#FEEFD7",
    stroke: "#976821"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 11H14V23H19C20.1046 23 21 22.1046 21 21V11Z",
    fill: "#FEEFD7",
    stroke: "#976821"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 7H14V23H10L10 7Z",
    stroke: "#976821"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 8C1 7.44772 1.44772 7 2 7L10 7V11H2C1.44772 11 1 10.5523 1 10L1 8Z",
    fill: "#FEEFD7",
    stroke: "#976821"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 8C23 7.44772 22.5523 7 22 7L14 7V11H22C22.5523 11 23 10.5523 23 10V8Z",
    fill: "#FEEFD7",
    stroke: "#976821"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 7C4.28574 5.00321 2.96706 3.00642 4.72529 1.40898C6.13188 0.131035 9.56059 1.80837 10 7Z",
    stroke: "#976821",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 7C19.7143 5.00321 21.0329 3.00642 19.2747 1.40898C17.8681 0.131035 14.4394 1.80837 14 7Z",
    stroke: "#976821",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gift-clip"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.5563fc53.svg";
export { ForwardRef as ReactComponent };